import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  static targets = [
    'textPreview',
    'backgroundPreview',
    'previewStyle',
    'solidColourInput',
    'gradientColourLeftInput',
    'gradientColourRightInput',
    'backgroundColourInput',
    'shadowColourInput',
  ];

  onSolidTextChange() {
    this.setEventTextColour(
      this.solidColourInputTarget.value,
      this.solidColourInputTarget.value,
    );
  }

  onGradientTextChange() {
    this.setEventTextColour(
      this.gradientColourLeftInputTarget.value,
      this.gradientColourRightInputTarget.value,
    );
  }

  onBackgroundColourChange() {
    this.backgroundPreviewTarget.style.background =
      this.backgroundColourInputTarget.value;
  }

  onShadowColourChange() {
    this.backgroundPreviewTarget.style.boxShadow = `0 0 20px ${this.shadowColourInputTarget.value}`;
  }

  setEventTextColour(left, right) {
    this.textPreviewTarget.style.backgroundImage = `linear-gradient(to right, ${left} 0%, ${right} 100%)`;
  }

  connect() {
    this.previewStyleTargets.forEach((previewStyleTargetItem) => {
      if (previewStyleTargetItem.checked) {
        this.previewStyle = previewStyleTargetItem.value;
      }
    });

    this.onBackgroundColourChange();
    this.onShadowColourChange();

    if (this.previewStyle === 'solid') return this.onSolidTextChange();

    this.onGradientTextChange();
  }
}
